import React from "react";
import "./p-policy.css";
import Images from "../../ALL_Images/Images.js";

export default function PrivacyPolicy() {
  return (
    <>
      <div class="section_ppolicy">
        <div class="container_ppolicy">
          <div class="content-section_ppolicy">
            <div class="image-section_ppolicy">
              <img src={Images.fodrixiconnew} alt=" not Found" />
            </div>
            <div class="title_ppolicy">
              <h1>Privacy Policy</h1>
            </div>
            <div class="content_ppolicy">
              <h3>OVERVIEW</h3>
              <p>
                {" "}
                Fodrix offers an internet-based service through its website,
                www.fodrix.com (the Site), that allows travellers to book a
                photoshoot in over 100+ cities in India by our site.
              </p>

              <p>
                {" "}
                Protecting our customer’s private information is our highest
                priority.
              </p>

              <p>
                This Privacy Policy governs all data collection and usage by
                Fodrix, including through the Site. By using the Site, you
                consent to the data collection and usage practices described in
                this Policy.
              </p>
            </div>
            <br />
            <div class="content_ppolicy">
              <h3>COLLECTION OF YOUR PERSONAL INFORMATION</h3>
              <p>
                {" "}
                We may request and collect certain personal information from our
                users, such as name, mailing address, email address, telephone,
                cellular and/or fax number, other wireless device address,
                credit/debit card and other payment information, and other
                contact information through various means such as account
                registration and maintenance, e-newsletter subscriptions,
                service orders, and contest entries, surveys and other online
                forms, questions, comments and communications to the sites,
                including but not limited to a “Contact Us” or similar feature
                on our sites, as well as through our blog(s), and through
                contributions open forum area of the sites. We may also obtain
                personal information about you from third-party sources.
              </p>

              <p>
                {" "}
                When you subscribe to any of our services, register for a
                newsletter, enter contests, contact us for any information or to
                ask a question, or participate in other on-line activities (e.g
                surveys, providing comments, participating in social media), you
                will be asked to provide certain personal information, which may
                include your name, street address, city, state, zip code, email
                address, and phone number (landline and/or mobile). It is always
                your choice whether or not to provide us with such personal
                information. However, if you do not provide the necessary
                information you may not be able to access some or all of the
                features of the service you are requesting. We also will have no
                way to respond to your questions or inquiries.
              </p>

              {/* <p>
              Fodrix encourages you to review the privacy statements of websites
              you choose to link to from the Fodrix website so that you can
              understand how those websites collect, use and share your
              information. Fodrix is not responsible for the privacy statements
              or other content on websites outside of the Site.
            </p> */}
            </div>
            <br />
            <div class="content_ppolicy">
              <h3>USE OF YOUR PERSONAL INFORMATION</h3>
              <p>
                We may use personal information collected on and through our
                sites for a variety of purposes in the course of our business
                and as otherwise set forth herein. For example, such information
                may be used to process your requests and orders, respond to your
                enquiries, or send you information about us and our business
                partners’ products and services and other information and
                materials that may be of interest to you. This information may
                also be used for internal recordkeeping, or to evaluate what
                portions of the sites are more popular than others, determine
                where visitors came from, where they go, and how long they stay
                on a particular page or a site in general. We may match
                information collected from you, including both personal
                information and website usage information, and use such
                information along with information obtained from other sources,
                including third parties to determine, for example, audience
                segments.
              </p>
              <p>
                We may analyze user behavior as a measure of interest in, and
                use of, our sites and emails, both on an individual basis and in
                the aggregate (that is, without any included personal
                information). We may disclose aggregate statistics regarding
                user behavior as a measure of interest in, and use of, our sites
                and emails to third parties in the form of aggregate data, such
                as overall patterns or demographic reports that do not describe
                or identify any individual user. We also may share this
                information with others, such as our affiliates, advertisers,
                third-party service providers (such as website or database
                hosting companies, address list hosting companies, email service
                providers, analytics companies, distribution companies,
                fulfillment companies, payment processors, and other similar
                service providers that use such information on our behalf) for
                or through the sites and other business partners. Some of these
                third parties may use such information, among other purposes, to
                contact you about offers or promotions that may be of interest
                to you.
              </p>
            </div>
            <br />
            <div class="content_ppolicy">
              <h3>COOKIES POLICY</h3>
              <p>
                {" "}
                By using or accessing the website, you are consenting to Fodrix
                to use cookies as follows:
              </p>
              <p>
                {" "}
                Cookies allow the website to remember important information that
                will make your use of the site more convenient. A cookie will
                typically contain the name of the domain from which the cookie
                has come, the "lifetime" of the cookie, and a randomly generated
                unique number or other value. Certain cookies will be used on
                the website regardless of whether you are logged in to your
                account or not.
              </p>
            </div>
            <br />
            <div class="content_ppolicy">
              <h3>We use cookies on the website for the following purposes:</h3>
              <p>
                {" "}
                <ol>
                  <li>
                    {" "}
                    - Determine if you are logged in or not, so you have not to
                    login every time you visit the site.
                  </li>
                  <li>
                    {" "}
                    - Remembering some of your settings and improving your
                    online experience.
                  </li>
                  <li>
                    {" "}
                    - Allowing you to edit your profile, add comments and title
                    to your photos.
                  </li>
                  <li> - Tailoring content to your needs.</li>
                </ol>
              </p>
            </div>
            <br />
            <div class="content_ppolicy">
              <h3>We do not use cookies to:</h3>
              <p>
                {" "}
                <ol>
                  <li> - Collect any personally identifiable information.</li>
                  <li> - Collect any sensitive information.</li>
                  <li>
                    {" "}
                    - Pass personally identifiable data to third parties.
                  </li>
                  <li> - Pay sales commissions.</li>
                </ol>
              </p>
              <p>
                {" "}
                Session cookies are temporary cookies that remain in the cookie
                file of your browser until you leave the website.
              </p>

              <p>
                {" "}
                Persistent cookies remain in the cookie file of your browser for
                much longer (though how long will depend on the lifetime of the
                specific cookie). We may employ persistent cookies so that we
                remember your computer when it is used to return to the website
                to help customize your photo web experience. Use the options in
                your web browser if you do not wish to receive a cookie or if
                you wish to set your browser to notify you when you receive a
                cookie. You can easily delete any cookies that have been
                installed in the cookie folder of your browser.
              </p>
              <p>
                {" "}
                If you disable all cookies, you may not be able to take
                advantage of all the features of the website. Social Media
                Platforms: You access our media properties through social media
                platforms, such as Facebook. When you do so, we may be able to
                access certain information in your platform profile, such as
                your name, email address, photos, gender, birthday, location,
                and platform ID, etc. Please refer to the terms of use and
                privacy policies for these social media platforms regarding your
                ability to control what information is provided to third
                parties.
              </p>
            </div>
            <br />
            <div class="content_ppolicy">
              <h3>HOW WE USE AND SHARE YOUR PERSONAL INFORMATION</h3>
              <p>
                {" "}
                We may use personal information collected on and through our
                sites for a variety of purposes in the course of our business
                and as otherwise set forth herein. For example, such information
                may be used to process your requests and orders, respond to your
                enquiries, or send you information about us and our business
                partners’ products and services and other information and
                materials that may be of interest to you. This information may
                also be used for internal recordkeeping, or to evaluate what
                portions of the sites are more popular than others, determine
                where visitors came from, where they go, and how long they stay
                on a particular page or a site in general. We may match
                information collected from you, including both personal
                information and website usage information, and use such
                information along with information obtained from other sources,
                including third parties to determine, for example, audience
                segments.
              </p>
              <p>
                {" "}
                We may analyze user behavior as a measure of interest in, and
                use of, our sites and emails, both on an individual basis and in
                the aggregate (that is, without any included personal
                information). We may disclose aggregate statistics regarding
                user behavior as a measure of interest in, and use of, our sites
                and emails to third parties in the form of aggregate data, such
                as overall patterns or demographic reports that do not describe
                or identify any individual user. We also may share this
                information with others, such as our affiliates, advertisers,
                third-party service providers (such as website or database
                hosting companies, address list hosting companies, email service
                providers, analytics companies, distribution companies,
                fulfillment companies, payment processors, and other similar
                service providers that use such information on our behalf) for
                or through the sites and other business partners. Some of these
                third parties may use such information, among other purposes, to
                contact you about offers or promotions that may be of interest
                to you.
              </p>
            </div>
            <br />
            <div class="content_ppolicy">
              <h3>POSTING OR SUBMITTING INFORMATION</h3>
              <p>
                {" "}
                All the photographs are the sole property of Fodrix and Fodrix
                has all right to share and use them. If any customer does not
                want Fodrix to share their photos, he/she has to give them in
                writing before the photography session.
              </p>
            </div>
            <br />

            <div class="content_ppolicy">
              <h3>DATA SECURITY</h3>
              <p>
                {" "}
                Fodrix has implemented reasonable and appropriate security
                measures and steps to ensure the security of the personal and
                other information we collect. Any third-party service providers
                with whom we may share personal information are contractually
                obligated to implement security measures no less robust and
                comprehensive. However, be advised that no method of
                transmitting or storing electronic data is ever completely
                secure, and we cannot guarantee that such information will never
                be accessed, used, or released in a manner that is inconsistent
                with this policy.
              </p>
              <p>
                {" "}
                If you register or create an account on one of our sites, you
                are responsible for maintaining the strict confidentiality of
                your login information, especially your ID and password. It is
                recommended that you should not share your login information
                with any other person. You are responsible for any access to or
                use of the sites by you or any person or entity using your login
                information, whether or not such access or use has been
                authorized by or on behalf of you, and whether or not such
                person or entity is your employee or agent. Fodrix will not be
                responsible for a breach that results from a piece of lost or
                stolen login information.
              </p>
              <p>
                {" "}
                In the unlikely event that we believe that the security of your
                personal information in our possession or control may have been
                compromised, we may seek to notify you about such activities. If
                a notification is appropriate, we would endeavor to do so as
                promptly as possible under the circumstances, and, to the extent
                we have your email address, we may notify you by email. You
                consent to our use of email as a means of such notification. If
                you prefer for us to use another method to notify you in this
                situation, please email us at support@fodrix.com with the
                alternative contact information you wish to be used.
              </p>
              <p>
                {" "}
                We will retain your personal information only for as long as
                your account is active and as needed to provide you services
                that you request. We will also retain personal information as
                necessary to comply with our legal obligations and applicable
                laws, resolve disputes, enforce our agreements, or fulfill our
                legitimate interests. After your account is closed or expires,
                we will continue to retain minimal personal information for
                purposes of contacting you for reactivation of your account
                (i.e., to renew the subscription to one or more of our
                magazines), unless you request to opt-out of receiving such
                requests as described below.
              </p>
            </div>
            <br />

            <div class="content_ppolicy">
              <h3>RIGHT TO OPT-OUT</h3>
              <p>
                {" "}
                You have the right to “opt-out” of certain of our uses of your
                personal information. For example, at the time you are requested
                to provide personal information on the sites, you may have the
                opportunity to elect to, or not to:
              </p>
              <p>
                {" "}
                (1) receive promotional or marketing material from us in the
                future,
                <br />
                (2) have your personal information disclosed to or shared with
                third parties in the future for their marketing purposes; or{" "}
                <br />
                (3) receive targeted advertising. At any time, you may opt-out
                of our emails by clicking on an opt-out or “Unsubscribe” link
                within the email you receive. You can also opt-out at any time
                of these practices and at any time by sending us an email at
                support@fodrix.com.
              </p>
            </div>
            <br />

            <div class="content_ppolicy">
              <h3>HOW TO ACCESS & CONTROL YOUR DATA</h3>
              <p> You have the following data protection rights:</p>
              <ul>
                <p>
                  {" "}
                  <li>
                    ⁕ You can request access, correction, updates, or deletion
                    of your personal information.
                  </li>
                  <li>
                    ⁕ You can object to the processing of your personal
                    information, ask us to restrict the processing of your
                    personal information or request portability of your personal
                    information.
                  </li>
                  <li>
                    ⁕ If we have collected and processed your personal
                    information with your consent, then you can withdraw your
                    consent at any time. Withdrawing your consent will not
                    affect the lawfulness of any processing we conducted before
                    your withdrawal, nor will it affect the processing of your
                    personal information conducted in reliance on lawful
                    processing grounds other than consent.
                  </li>
                  <li>
                    ⁕ You have the right to complain to a data protection
                    authority or other relevant parties about our collection and
                    use of your personal information.
                  </li>
                </p>
              </ul>
              <p>
                To exercise any of these rights, please contact us at
                support@fodrix.com.
              </p>
            </div>
            <br />

            <div class="content_ppolicy">
              <h3>LOCATED IN THE INDIA</h3>
              <p>
                {" "}
                We are located in India and our sites and servers are maintained
                in India. If you are located outside India, your personal
                information will be transferred to and processed in India, which
                has data protection laws that may be different than those in
                your country and may not be as protective. By providing any
                personal information to any of our sites, you fully understand
                and unambiguously consent to the transfer of such personal
                information to, and the collection and processing of such
                Personal Information in, India.
              </p>
            </div>
            <br />

            <div class="content_ppolicy">
              <h3>LINKS</h3>
              <p>
                {" "}
                The sites may contain links or references to other websites
                outside of our control. Please be aware that we have no control
                over these third-party websites, that these websites may collect
                personal information about you, and that our Privacy Policy does
                not apply to these websites.
              </p>
            </div>
            <br />

            <div class="content_ppolicy">
              <h3>DO-NOT-TRACK</h3>
              <p>
                {" "}
                We currently do not honor browser-based Do-Not-Track signals.
              </p>
            </div>
            <br />

            <div class="content_ppolicy">
              <h3>CHILDREN’S PRIVACY</h3>
              <p>
                {" "}
                The sites are intended to be accessed and used by persons at
                least 18 years or older. Fodrix does not knowingly collect or
                maintain information on the sites or any services from persons
                we know to be under age 18, and no part of our sites is designed
                to attract anyone under age 18. If a child under the age of 18
                has provided us with their personal information, we ask that
                their parent or guardian contact us as provided below to inform
                us of that fact. We will use reasonable efforts to delete such
                information from our systems and servers.
              </p>
            </div>
            <br />
            <div class="content_ppolicy">
              <h3>CHANGES TO THE PRIVACY POLICY</h3>
              <p>
                {" "}
                The latest updated date of the current version of the Privacy
                Policy is provided below. From time to time we may modify this
                Privacy Policy. We will notify you of any material change by
                sending a notice to the e-mail address you provided to us or by
                placing a prominent notice on our Site. You can view the most
                recent version of the Privacy Policy at any time by clicking the
                “Privacy Policy” link at the bottom of each Site’s homepage.
                Your continued use of the site after any modification indicates
                your agreement to the new terms and conditions.
              </p>
            </div>
            <br />
            <div class="content_ppolicy">
              <h3>CHANGES TO THIS POLICY</h3>
              <p>
                {" "}
                Fodrix will occasionally update this Privacy Policy to reflect
                company and customer feedback. Fodrix encourages you to
                periodically review this Policy to be informed of how Fodrix is
                protecting your information.
              </p>
            </div>
            <br />
            <div class="content_ppolicy">
              <h3>CONTACT INFORMATION</h3>
              <p>
                {" "}
                If you have any questions or comments regarding this Privacy
                Policy, you may contact us at:
                <br /> Email: support@fodrix.com
                <br />
                <br />
                Website:<a href="https://www.fodrix.com"> fodrix.com</a>
                <br />
                <br />
                Phone: +91-7020147576
                <br />
              </p>
            </div>
            <br />
            {/* <div class="social">
            <a href="https://www.facebook.com/fodrix">
              <i class="fab fa-facebook-f"></i>
            </a>
            <a href="https://twitter.com/fodrixx">
              <i class="fab fa-twitter"></i>
            </a>
            <a href="https://www.instagram.com/fodrixx/">
              <i class="fab fa-instagram"></i>
            </a>
            <a href="https://www.linkedin.com/company/fodrix/">
              <i class="fab fa-linkedin"></i>
            </a>
            <a href="https://www.youtube.com/watch?v=gvWu9sw-iK4">
              <i class="fab fa-youtube"></i>
            </a>
          </div> */}
          </div>
        </div>
      </div>
    </>
  );
}
